module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-voxi-bottom-01.2@2x.cb202d0a.jpg";